import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import ListRatesComponent from "../Views/ListRatesComponent";
import AddRatesComponent from "../Views/AddRatesComponent";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import {Guard} from "../Common/Guard";
import {PERMS} from "../../Utils/Permissions";
import styled from "styled-components";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, Tabs, DataTable, Spinner, StatusBadge, EmptyState, Modal, FormField, TextInput} from "../UI";
import {tokens} from "../../theme/tokens";

const kes = (n) => `KES ${(Number(n) || 0).toFixed(2)}`;

const invoiceTone = (s) => {
    const v = (s || "").toUpperCase();
    if (v === "PAID") return "success";
    if (v === "UNPAID") return "danger";
    return "warn";
};

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        border-bottom: 1px solid ${tokens.colors.divider};
        font-size: ${tokens.typography.size.base};
        vertical-align: top;
    }
    td:first-child {
        color: ${tokens.colors.muted};
        width: 40%;
    }
    td:last-child {
        color: ${tokens.colors.heading};
    }
    tr:last-child td {
        border-bottom: 0;
    }
`;

const DepartmentDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({name: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [tab, setTab] = useState("details");

    const [requestsListOngoing, setRequestListOngoing] = useState([]);
    const [requestsListAll, setRequestListAll] = useState([]);
    const [businessList, setBusinessList] = useState([]);
    const [invoices, setInvoices] = useState([]);

    // Record-payment modal (audit reason auto-prompted by postData).
    const [paymentInvoice, setPaymentInvoice] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState('');

    const columns = [
        {
            name: '#',
            sortable: true,
            cell: row => <div><Link to={"/request/" + row.id}>{row.request_code}</Link></div>,
        },
        {
            name: 'Type',
            selector: 'pick_up_type',
            sortable: true,
        },
        {
            name: 'Pick up',
            selector: 'pick_up_location',
            sortable: true,
        },
        {
            name: 'Delivery type',
            selector: 'delivery_type',
            sortable: true,
        },
        {
            name: 'Means',
            selector: 'means',
            sortable: true,
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
        },
        {
            name: 'Fee',
            selector: 'fee',
            sortable: true,
        }
    ]

    const businessColumns = [
        {
            name: 'Email',
            sortable: true,
            cell: row => <div><Link to={"/account/" + row.id}>{row.email}</Link></div>,
        },
        {
            name: 'Invitation Status',
            cell: row => row.accepted === 1 ? <span>Accepted</span> : <span>Pending</span>,
        },
        {
            name: 'Client Status',
            cell: row => row.active === 1 ? <span>Active</span> : <span>Inactive</span>,
        },
        {
            name: 'Admin Status',
            cell: row => row.admin_active === 1 ? <span>Active</span> : <span>Inactive</span>,
        }
    ]

    const invoiceColumns = [
        {name: 'Invoice', grow: 1, cell: row => <span style={{fontWeight: 600}}>{row.invoice_code || `#${row.id}`}</span>},
        {name: 'Raised', grow: 1, selector: 'date_added_string'},
        {name: 'Amount', grow: 1, right: true, cell: row => kes(row.amount)},
        {name: 'Paid', grow: 1, right: true, cell: row => kes(row.amount_paid)},
        {name: 'Status', grow: 1, cell: row => <StatusBadge tone={invoiceTone(row.status)}>{row.status}</StatusBadge>},
        {name: 'Due', grow: 1, selector: 'due_date_string'},
        {
            name: '', grow: 2, right: true,
            cell: row => (
                <Guard permission={PERMS.FINANCIAL_WRITE}>
                    <div style={{display: 'flex', gap: tokens.spacing[2], justifyContent: 'flex-end'}}>
                        <Button size="sm" variant="outline" onClick={() => { setPaymentInvoice(row); setPaymentAmount(''); }}>
                            Record payment
                        </Button>
                        {(row.status || '').toUpperCase() !== 'PAID' &&
                        <Button size="sm" onClick={() => markInvoicePaid(row.id)}>Mark paid</Button>}
                    </div>
                </Guard>
            ),
        },
    ]

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.DEPARTMENT_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    updateDocumentTitle(res.data.name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
        loadRequests(false, "business")
        loadAccounts(false)
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.DEPARTMENT_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(SUCCESS ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);

                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const loadRequests = (loadMore, status) => {
        let data = new FormData();
        data.append("department_id", id);
        data.append("status", status);
        data.append("offset", requestsListOngoing.length);

        setIsLoading(true);

        postData(Endpoints.REQUEST_LIST_USER, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                let currentPosts = loadMore ? requestsListOngoing : [];
                currentPosts = currentPosts.concat(...res.data);
                setRequestListOngoing(currentPosts);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    const loadAccounts = (loadMore) => {
        let data = new FormData();
        data.append("department_id", id);

        setIsLoading(true);

        postData(Endpoints.CHILD_ACCOUNT_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                let currentPosts = loadMore ? businessList : [];
                currentPosts = currentPosts.concat(...res.data);
                setBusinessList(currentPosts);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };


    const loadInvoices = (businessId) => {
        const bid = businessId || item.business_id;
        if (!bid) return;
        let data = new FormData();
        data.append("business_id", bid);
        data.append("department_id", id);
        postData(Endpoints.INVOICE_LIST_ADMIN, data)
            .then(res => res.json())
            .then(res => setInvoices((res && res.data) || []))
            .catch((error) => console.log(error));
    };

    // Invoices need the business id, which only arrives with the loaded department.
    useEffect(() => {
        if (item.business_id) loadInvoices(item.business_id);
    }, [item.business_id]);

    const generateInvoice = () => {
        let data = new FormData();
        data.append("business_id", item.business_id);
        data.append("department_id", id);
        setIsLoading(true);
        postData(Endpoints.INVOICE_GENERATE_ADMIN, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? (res.data || "Invoices generated") : (res.message || res.error || "Failed"),
                    res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) loadInvoices();
            })
            .catch((error) => { setIsLoading(false); console.log(error); });
    };

    const markInvoicePaid = (invId) => {
        const fd = new FormData();
        fd.append('id', invId);
        postData(Endpoints.INVOICE_UPDATE_STATUS_ADMIN, fd)
            .then(res => res.json())
            .then(() => loadInvoices())
            .catch((err) => console.log(err));
    };

    const submitPayment = () => {
        if (!paymentInvoice) return;
        const amount = parseFloat(paymentAmount);
        if (!Number.isFinite(amount) || amount <= 0) return;
        const fd = new FormData();
        fd.append('id', paymentInvoice.id);
        fd.append('amount', String(amount));
        postData(Endpoints.INVOICE_UPDATE_PAYMENT_ADMIN, fd)
            .then(res => res.json())
            .then(() => {
                setPaymentInvoice(null);
                setPaymentAmount('');
                loadInvoices();
            })
            .catch((err) => console.log(err));
    };

    return (
        <PageLayout
            title={item.name}
            actions={item.name !== '' ? (
                <>
                    {isLoading && <Spinner size={20}/>}
                    {!isLoading &&
                    <Button
                        variant={item.admin_active === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.admin_active === 1 ? 0 : 1)}
                    >
                        {item.admin_active === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    <Link to={"/business/" + item.business_id}>
                        <Button variant="outline">Back to business</Button>
                    </Link>
                </>
            ) : null}
        >
            {item.name !== '' &&
            <>
                <Tabs
                    tabs={[
                        {key: "details", label: "Details"},
                        {key: "accounts", label: "Billing accounts"},
                        {key: "invoices", label: "Invoices"},
                        {key: "requests", label: "Requests made"},
                        {key: "rates", label: "Rates & Charges"},
                    ]}
                    value={tab}
                    onChange={setTab}
                />

                {tab === "details" &&
                <Card>
                    <InfoTable>
                        <tbody>
                        <tr>
                            <td>Name</td>
                            <td><b>{item.name}</b></td>
                        </tr>
                        <tr>
                            <td>Contact e-mail</td>
                            <td><b>{item.contact_email}</b></td>
                        </tr>
                        <tr>
                            <td>Contact phone</td>
                            <td><b>{item.contact_phone}</b></td>
                        </tr>
                        <tr>
                            <td>This month's requests</td>
                            <td><b>{item.this_months_requests}</b></td>
                        </tr>
                        <tr>
                            <td>This month's bill</td>
                            <td><b>{item.this_month_string}</b></td>
                        </tr>
                        <tr>
                            <td>Invoice email</td>
                            <td><b>{item.invoice_email}</b></td>
                        </tr>
                        <tr>
                            <td>Monthly budget</td>
                            <td><b>{item.monthly_budget_string}</b></td>
                        </tr>
                        <tr>
                            <td>Client Status</td>
                            <td><b>{item.active === 0 ? "INACTIVE" : "ACTIVE"}</b></td>
                        </tr>
                        <tr>
                            <td>Admin Status</td>
                            <td><b>{item.admin_active === 0 ? "INACTIVE" : "ACTIVE"}</b></td>
                        </tr>
                        <tr>
                            <td>Registered on</td>
                            <td><b>{item.date_added_string}</b></td>
                        </tr>
                        </tbody>
                    </InfoTable>
                </Card>
                }

                {tab === "invoices" &&
                <>
                    <Guard permission={PERMS.FINANCIAL_WRITE}>
                        <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: tokens.spacing[3]}}>
                            <Button onClick={generateInvoice}>Generate invoice</Button>
                        </div>
                    </Guard>
                    <Card padded={false}>
                        <DataTable
                            columns={invoiceColumns}
                            data={invoices}
                            noHeader={true}
                            noDataComponent={
                                <EmptyState
                                    title="No invoices yet"
                                    description="No invoices yet — generate one or wait for the monthly billing run."
                                />
                            }
                        />
                    </Card>
                </>
                }

                {tab === "requests" &&
                <Card padded={false}>
                    <DataTable
                        columns={columns}
                        data={requestsListOngoing}
                        pointerOnHover={true}
                        noHeader={true}
                        onRowClicked={e => {
                            history.push('/request/' + e.id);
                        }}
                    />
                </Card>
                }

                {tab === "accounts" &&
                <Card padded={false}>
                    <DataTable
                        columns={businessColumns}
                        data={businessList}
                        pointerOnHover={true}
                        noHeader={true}
                        onRowClicked={e => {
                            history.push('/account/' + e.id);
                        }}
                    />
                </Card>
                }

                {tab === "rates" &&
                <div className="row">
                    <div className="col-md-8">
                        <ListRatesComponent department={id}/>
                    </div>
                    <div className="col-md-4">
                        <AddRatesComponent/>
                    </div>
                </div>
                }
            </>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate department" : "Activate department"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }

            {paymentInvoice &&
            <Modal
                open={!!paymentInvoice}
                onClose={() => setPaymentInvoice(null)}
                title="Record a payment"
                subtitle={`Invoice ${paymentInvoice.invoice_code || paymentInvoice.id} — outstanding ${kes((paymentInvoice.amount || 0) - (paymentInvoice.amount_paid || 0))}`}
                actions={
                    <>
                        <Button variant="ghost" onClick={() => setPaymentInvoice(null)}>Cancel</Button>
                        <Button disabled={!paymentAmount} onClick={submitPayment}>Record payment</Button>
                    </>
                }
            >
                <FormField label="Payment amount (KES)" htmlFor="paymentAmount">
                    <TextInput
                        id="paymentAmount"
                        type="number" min="0" step="0.01"
                        value={paymentAmount}
                        onChange={(e) => setPaymentAmount(e.target.value)}
                        autoFocus
                    />
                </FormField>
            </Modal>
            }
        </PageLayout>
    )
};


export default DepartmentDetails
